import IconFeature from "@/components/IconFeature";
import TrophyIcon from "@/components/icons/TrophyIcon";
import StarIcon from "@/components/icons/StarIcon";
import ShieldIcon from "@/components/icons/ShieldIcon";
import FeesIcon from "@/components/icons/FeesIcon";
import Panel from "@/components/Panel";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay} from "swiper/modules";
import {useAppState} from "@/store";

export default function Features() {
    const {state} = useAppState()
    return (
        <Panel passive={true}>
            <Swiper
                modules={[Autoplay]}
                spaceBetween={32}
                slidesPerView={1}
                autoplay={true}
                loop={true}
                centerInsufficientSlides={true}
                breakpoints={{1024: {slidesPerView: 4}}}
            >
                <SwiperSlide>
                    <IconFeature icon={<TrophyIcon/>} title={"Award-Winning"} subtitle={"55 awards won and counting!"}/>
                </SwiperSlide>
                <SwiperSlide>
                    <IconFeature icon={<StarIcon/>} title={"4.9/5 Stars"} subtitle={"8,000+ reviews"}/>
                </SwiperSlide>
                <SwiperSlide>
                    <IconFeature icon={<ShieldIcon/>} title={"Fully Insured"} subtitle={"$2,000 coverage"}/>
                </SwiperSlide>
                {(!state.branch || state.branch.tripFees === 0) && (
                    <SwiperSlide>
                        <IconFeature icon={<FeesIcon/>} title={"No Hidden Fees"} subtitle={"Seriously, none"}/>
                    </SwiperSlide>
                )}
            </Swiper>
        </Panel>
    )
}
